import type { Load } from '@sveltejs/kit';
import { error, redirect } from '@sveltejs/kit';
import { load as externalLoad } from '@glimja/storefront/pages/collections/paths';
import { bindSveltKitLoad } from '@glimja/storefront/utils';

export const load: Load = bindSveltKitLoad(externalLoad, error, redirect)
